import axios from "axios";
import { API_ENDPOINT } from "@/config/constants";

const appApi = axios.create({
  baseURL: API_ENDPOINT
});

export default appApi;
